import { LoadingPage } from '@src/common/components/LoadingPage';
import { Stack } from '@src/common/components/Stack';
import { ToastProvider } from '@src/common/context/ToastProvider';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import type { ReactNode } from 'react';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export const Layout = ({ SideNav }: { SideNav: () => ReactNode }) => {
  return (
    <Stack direction="row" className={container} flex={1}>
      <SideNav />

      <main className={mainContent}>
        <Suspense fallback={<LoadingPage />}>
          <ToastProvider>
            <Outlet />
          </ToastProvider>
        </Suspense>
      </main>
    </Stack>
  );
};

const container = css({
  minHeight: '100vh',
  backgroundColor: theme.palette.surface.surface,
});

const mainContent = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});
